'use client';

import React, { memo } from 'react';

interface AppLogoProps {
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const fontSize = Math.round(size * 0.42);
  const containerClass = ['flex items-center justify-center flex-shrink-0', onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : '', className].filter(Boolean).join(' ');

  return (
    <div
      className={containerClass}
      onClick={onClick}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.22),
        background: 'linear-gradient(135deg, #D4A017 0%, #B8860B 100%)',
        boxShadow: '0 2px 8px rgba(212,160,23,0.35)',
      }}
    >
      <span
        style={{
          fontSize,
          fontWeight: 800,
          color: '#fff',
          letterSpacing: '-0.03em',
          lineHeight: 1,
          fontFamily: 'inherit',
        }}
      >
        AT
      </span>
    </div>
  );
});

export default AppLogo;
